import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import capitalize from '../../_util/capitalize';
import { resetComponent } from '../../style';
import { genComponentStyleHook, genPresetColor, mergeToken } from '../../theme/internal';

var genTagStatusStyle = function genTagStatusStyle(token, status, cssVariableType) {
  var capitalizedCssVariableType = capitalize(cssVariableType);
  return _defineProperty({}, "".concat(token.componentCls, "-").concat(status), _defineProperty({
    color: token["color".concat(cssVariableType)],
    background: token["color".concat(capitalizedCssVariableType, "Bg")],
    borderColor: token["color".concat(capitalizedCssVariableType, "Border")]
  }, "&".concat(token.componentCls, "-borderless"), {
    borderColor: 'transparent'
  }));
};

var genPresetStyle = function genPresetStyle(token) {
  return genPresetColor(token, function (colorKey, _ref) {
    var textColor = _ref.textColor,
        lightBorderColor = _ref.lightBorderColor,
        lightColor = _ref.lightColor,
        darkColor = _ref.darkColor;
    return _defineProperty({}, "".concat(token.componentCls, "-").concat(colorKey), _defineProperty({
      color: textColor,
      background: lightColor,
      borderColor: lightBorderColor,
      // Inverse color
      '&-inverse': {
        color: token.colorTextLightSolid,
        background: darkColor,
        borderColor: darkColor
      }
    }, "&".concat(token.componentCls, "-borderless"), {
      borderColor: 'transparent'
    }));
  });
};

var genBaseStyle = function genBaseStyle(token) {
  var _checkable, _Object$assign, _ref4;

  var paddingXXS = token.paddingXXS,
      lineWidth = token.lineWidth,
      tagPaddingHorizontal = token.tagPaddingHorizontal,
      componentCls = token.componentCls;
  var paddingInline = tagPaddingHorizontal - lineWidth;
  var iconMarginInline = paddingXXS - lineWidth;
  return _ref4 = {}, _defineProperty(_ref4, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    display: 'inline-block',
    height: 'auto',
    marginInlineEnd: token.marginXS,
    paddingInline: paddingInline,
    fontSize: token.tagFontSize,
    lineHeight: token.tagLineHeight,
    whiteSpace: 'nowrap',
    background: token.defaultBg,
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBorder),
    borderRadius: token.borderRadiusSM,
    opacity: 1,
    transition: "all ".concat(token.motionDurationMid),
    textAlign: 'start',
    position: 'relative'
  }, _defineProperty(_Object$assign, "&".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  }), _defineProperty(_Object$assign, '&, a, a:hover', {
    color: token.defaultColor
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-close-icon"), {
    marginInlineStart: iconMarginInline,
    color: token.colorTextDescription,
    fontSize: token.tagIconSize,
    cursor: 'pointer',
    transition: "all ".concat(token.motionDurationMid),
    '&:hover': {
      color: token.colorTextHeading
    }
  }), _defineProperty(_Object$assign, "&".concat(componentCls, "-has-color"), _defineProperty({
    borderColor: 'transparent'
  }, "&, a, a:hover, ".concat(token.iconCls, "-close, ").concat(token.iconCls, "-close:hover"), {
    color: token.colorTextLightSolid
  })), _defineProperty(_Object$assign, "&-checkable", (_checkable = {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    cursor: 'pointer'
  }, _defineProperty(_checkable, "&:not(".concat(componentCls, "-checkable-checked):hover"), {
    color: token.colorPrimary,
    backgroundColor: token.colorFillSecondary
  }), _defineProperty(_checkable, '&:active, &-checked', {
    color: token.colorTextLightSolid
  }), _defineProperty(_checkable, '&-checked', {
    backgroundColor: token.colorPrimary,
    '&:hover': {
      backgroundColor: token.colorPrimaryHover
    }
  }), _defineProperty(_checkable, '&:active', {
    backgroundColor: token.colorPrimaryActive
  }), _checkable)), _defineProperty(_Object$assign, "&-hidden", {
    display: 'none'
  }), _defineProperty(_Object$assign, "> ".concat(token.iconCls, " + span, > span + ").concat(token.iconCls), {
    marginInlineStart: paddingInline
  }), _Object$assign))), _defineProperty(_ref4, "".concat(componentCls, "-borderless"), {
    borderColor: 'transparent',
    background: token.tagBorderlessBg
  }), _ref4;
}; // ============================== Export ==============================


export default genComponentStyleHook('Tag', function (token) {
  var lineWidth = token.lineWidth,
      fontSizeIcon = token.fontSizeIcon;
  var tagFontSize = token.fontSizeSM;
  var tagLineHeight = "".concat(token.lineHeightSM * tagFontSize, "px");
  var tagToken = mergeToken(token, {
    tagFontSize: tagFontSize,
    tagLineHeight: tagLineHeight,
    tagIconSize: fontSizeIcon - 2 * lineWidth,
    tagPaddingHorizontal: 8,
    tagBorderlessBg: token.colorFillTertiary
  });
  return [genBaseStyle(tagToken), genPresetStyle(tagToken), genTagStatusStyle(tagToken, 'success', 'Success'), genTagStatusStyle(tagToken, 'processing', 'Info'), genTagStatusStyle(tagToken, 'error', 'Error'), genTagStatusStyle(tagToken, 'warning', 'Warning')];
}, function (token) {
  return {
    defaultBg: token.colorFillQuaternary,
    defaultColor: token.colorText
  };
});